import api from "PFCore/api";

export type SaveConversationPayload = {
  target: string;
  ownerId?: number;
  withMessage?: boolean;
};

type SaveConversationResponse = {
  id: number;
};

export const saveConversation = ({
  target,
  ownerId
}: SaveConversationPayload): Promise<SaveConversationResponse> =>
  api({
    url: "chat/conversations",
    method: "POST",
    data: {
      target,
      ownerId
    }
  });
